import { DslParser } from '../common';
import { statementSchemaHandlerList } from './stmtsList';
export const createSchemaDslParser = () => {
    return new DslParser(statementSchemaHandlerList());
};
//# sourceMappingURL=createSchemaDslParser.js.map